<template>
  <div class="p-2">
    <div class="grid-wrapper">
      <div class="nested-grid-wrapper">
        <div class="card">
          <div class="card-body">
            <table class="table table-sm mb-0 general-info-table">
              <tr v-if="$hasPermission('view_identity_verification')">
                <td class="border-top-0 pb-2"><b>{{ $t('Identity Verification') }}</b></td>
                <td class="border-top-0 pb-2">
                  <select2 :items="identityVerificationTypes" :options="{
                    placeholder: $t('Identity Verification'),
                    minimumResultsForSearch: Infinity,
                    allowClear: false}"
                           :clearable="false"
                           value-field="value" display-field="${item.key}"
                           :name="`identity_verification-${customer.uuid}`"
                           :key="`identity_verification-${customer.uuid}`" v-model="identity_verification"
                           @select="onIdentificationVerificationChange"/>

                </td>
                <td class="border-top-0"></td>
              </tr>
              <tr v-if="$hasPermission('view_identity_verification') && identity_verification === 'unverified'" >
                <td class="border-top-0 pb-2"><b>{{ $t('Identity Verification Reject Comment') }}</b></td>
                <td class="border-top-0 pb-2">{{termsData.identity_verification_rejected_reason}}</td>
              </tr>
              <tr v-if="$hasPermission('view_identity_verification')">
                <td class="border-top-0 pb-2"><b>{{ $t('Account/KYC Approved') }}</b></td>
                <td class="border-top-0 pb-2">
                  <select2 :items="kycVerificationTypes" :options="{
                    placeholder: $t('Account/KYC Approved'),
                    minimumResultsForSearch: Infinity,
                    allowClear: false}"
                           :clearable="false"
                           value-field="value" display-field="${item.key}"
                           :name="`kyc_status_verification-${customer.uuid}`"
                           :key="`kyc_status_verification-${customer.uuid}`" v-model="kyc_status_verification"
                           @select="onKYCVerificationChange"/>
                </td>
                <td class="border-top-0"></td>
              </tr>
               <tr v-if="$hasPermission('view_identity_verification') && kyc_status_verification === 'unverified'" >
                <td class="border-top-0 pb-2"><b>{{ $t('Account/KYC Verification Reject Comment') }}</b></td>
                <td class="border-top-0 pb-2">{{termsData.kyc_rejected_reason}}</td>
              </tr>
              <tr>
                <td class="border-top-0 pb-2"><b>{{ $t('Credit Card Verification') }}</b></td>
                <td class="border-top-0 pb-2">
                  <b-form-checkbox :checked="credit_card_verified" size="lg"
                                   @change="onCreditCardVerificationCheckChange"
                                   switch>
                  </b-form-checkbox>
                </td>
                <td class="border-top-0"></td>
              </tr>
              <tr>
                <td class="border-top-0 pb-2"><b>{{ $t('Pre-approve Commission Bids') }}</b></td>
                <td class="border-top-0 pb-2">
                  <b-form-checkbox :checked="pre_approve_commission_bids" size="lg"
                                   @change="onPreApproveCommissionBidsCheckChange"
                                   switch>
                  </b-form-checkbox>
                </td>
                <td class="border-top-0"></td>
              </tr>

              <tr>
                <td class="border-top-0 pb-2"><b>{{ $t('Pre-approve Telephone Bids') }}</b></td>
                <td class="border-top-0 pb-2">
                  <b-form-checkbox :checked="pre_approve_telephone_bids" size="lg"
                                   @change="onPreApproveTelephoneBidsCheckChange"
                                   switch>
                  </b-form-checkbox>
                </td>
                <td class="border-top-0"></td>
              </tr>


              <tr>
                <td class="border-top-0 pb-2"><b>{{ $t('Being Collected') }}</b></td>
                <td class="border-top-0 pb-2">
                  <b-form-checkbox :checked="is_pickup" size="lg"
                                   @change="onPickupChange"
                                   switch>
                  </b-form-checkbox>
                </td>
                <td class="border-top-0"></td>
              </tr>
              <tr v-permission="'view_customerbankaccount'" v-if="hasStripeProvider">
                <td class="border-top-0 pb-2"><b>{{ $t('Exclude from Auto-Payments') }}</b></td>
                <td class="border-top-0 pb-2">
                  <b-form-checkbox :checked="exclude_from_auto_payments" size="lg"
                                   @change="onExcludeFromAutoPaymentsCheckChange"
                                   :disabled="!$hasPermission('change_customerbankaccount')"
                                   switch>
                  </b-form-checkbox>
                </td>
                <td class="border-top-0"></td>
              </tr>
              <tr v-if="!isSalesTaxEnabled">
                <td><b>{{ $t('Tax Status') }}</b></td>
                <td>{{ currentTaxStatusName }}</td>
                <td>
                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                            @click="toggleTaxStatusModal(true)">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
<!--              <tr v-if="!isSalesTaxEnabled">-->
<!--                <td><b>{{ $t('Tax Rate') }}</b></td>-->
<!--                <td>-->
<!--                  <span v-if="tax_rate">{{ tax_rate | asPercentage }}</span>-->
<!--                </td>-->
<!--                <td>-->
<!--                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"-->
<!--                            @click="toggleTaxRateModal(true)">-->
<!--                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"/>-->
<!--                    {{ $t('Edit') }}-->
<!--                  </b-button>-->
<!--                </td>-->
<!--              </tr>-->
              <tr>
                <td><b>{{ $t('Bidding Limit') }}</b></td>
                <template v-if="currentBranch.enable_trust_levels">
                  <td>
                    <table class="table-sm mb-0" v-if="currentTrustLevel">
                      <tr>
                        <td class="bt-0">{{ $t('Name') }}</td>
                        <td class="bt-0">{{ currentTrustLevel.name }}</td>
                      </tr>
                      <tr>
                        <td class="bt-0">{{ $t('Bidding Limit') }}</td>
                        <td class="bt-0">{{ currentTrustLevel.credit_limit | asCurrency }}</td>
                      </tr>
                      <tr>
                        <td class="bt-0">{{ $t('Threshold') }}</td>
                        <td class="bt-0">{{ currentTrustLevel.threshold | asCurrency }}</td>
                      </tr>
                      <tr>
                        <td class="bt-0">{{ $t('Auto Promotion') }}</td>
                        <td class="bt-0">
                          <span v-if="!currentTrustLevel.disable_auto_promotion"
                                class="badge bg-success text-white">{{ $t('Yes') }}</span>
                          <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                              @click="toggleTrustLevelModal(true)">
                      <font-awesome-icon :icon="'pen'" style="font-size: .9em"
                                         v-if="currentTrustLevel"></font-awesome-icon>
                      <font-awesome-icon :icon="'plus'" style="font-size: .9em" v-else></font-awesome-icon>
                      {{ $t(currentTrustLevel ? 'Edit' : 'Add') }}
                    </b-button>
                  </td>
                </template>
                <template v-else>
                  <td>
                    <span v-if="credit_limit">{{ credit_limit | asCurrency }}</span>
                  </td>
                  <td>
                    <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                              @click="toggleCreditLimitModal(true)">
                      <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                      {{ $t('Edit') }}
                    </b-button>
                  </td>
                </template>
              </tr>
              <tr>
                <td><b>{{ $t('Payment Terms') }}</b></td>
                <td>{{ $t("{count} days", {count: payment_terms}) }}</td>
                <td>
                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                            @click="togglePaymentTermsModal(true)">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
              <tr>
                <td><b>{{ $t('Settlement Days') }}</b></td>
                <td>{{ $t("{count} days", {count: settlement_days}) }}</td>
                <td>
                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                            @click="toggleSettlementDaysModal(true)">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
              <tr>
                <td><b>{{ $t('VAT Number') }}</b></td>
                <td>
                  <span v-if="vat_number">{{ vat_number }}</span>
                </td>
                <td>
                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                            @click="toggleVatNumberModal(true)">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
              <tr>
                <td><b>{{ $t('Payment Method') }}</b></td>
                <td>
                  <span v-if="payment_method">{{ payment_method | asPaymentMethod }}</span>
                </td>
                <td>
                  <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                            @click="togglePaymentMethodModal(true)">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
              <tr v-for="([name, config]) in Object.entries(currentBranch.customer_terms_dynamic_fields_template)"
                            :key="name">
                <td><b>{{ config.label }}</b></td>
                <td v-if="config.type==='checkbox'"class="border-top-0 pb-2">
                  <b-form-checkbox :checked="getDynamicFieldValue(name, config.type)" size="lg"
                            @change="(checked) => onDynamicFieldToggle({name: name, label: config.label}, checked)"
                            switch>
                  </b-form-checkbox>
                </td>
                <td v-else>
                  <span v-if="getDynamicFieldValue(name, config.type)">{{ getDynamicFieldValue(name, config.type) }}</span>
                </td>
                <td class="border-top-0">
                  <b-button v-if="config.type!=='checkbox'" v-permission="'change_customer'" class="float-right p-0"
                            variant="link" @click="toggleDynamicFieldModal({show: true, name: name})">
                    <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
                    {{ $t('Edit') }}
                  </b-button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="card" v-permission="'view_customerbankaccount'">
        <div class="card-header">
          <h5 class="d-inline-block mb-0">
            {{ $t('Bank Account') }}
          </h5>
          <b-button class="float-right p-0" variant="link"
                    v-permission="'change_customerbankaccount'"
                    @click="toggleBankAccountModal(true)">
            <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Edit') }}
          </b-button>
          <b-button class="float-right p-0 mr-2 text-danger" variant="link" v-permission="'delete_customerbankaccount'"
                    v-if="bank_account" @click="onBankAccountRemoveClick">
            <font-awesome-icon icon="times" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Remove') }}
          </b-button>
        </div>
        <div class="card-body">
          <table v-if="bank_account" class="info-table table mb-0 table-sm">
            <tr>
              <td class="border-top-0 font-weight-bold">{{ $t('Account Name/Beneficiary') }}</td>
              <td class="border-top-0">{{ bank_account.account_name }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Sort Code') }}</td>
              <td>{{ bank_account.sort_code }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Account Number') }}</td>
              <td>{{ bank_account.account_number }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('IBAN') }}</td>
              <td>{{ bank_account.iban }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Swift') }}</td>
              <td>{{ bank_account.swift }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Bank Name') }}</td>
              <td>{{ bank_account.bank_name }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Address 1') }}</td>
              <td>{{ bank_account.address }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Address 2') }}</td>
              <td>{{ bank_account.address_2 }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Address 3') }}</td>
              <td>{{ bank_account.address_3 }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Contact First Name') }}</td>
              <td>{{ bank_account.first_name }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Contact Last Name') }}</td>
              <td>{{ bank_account.last_name }}</td>
            </tr>
            <tr>
              <td class="font-weight-bold">{{ $t('Contact Email') }}</td>
              <td>{{ bank_account.email }}</td>
            </tr>
          </table>
          <no-data-available v-else :height="10"/>
        </div>
      </div>
      <div class="card" v-if="$hasPermission('view_customeridentification') && identification" style="max-height: 40em">
        <div class="card-header">
          <h5 class="d-inline-block mb-0">
            {{ $t('Identification Details') }}
          </h5>
          <b-button class="float-right p-0" variant="link"
                    v-permission="'change_customeridentification'"
                    @click="onIdentificationDetailsEditClick(true)">
            <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
            {{ $t('Edit') }}
          </b-button>
        </div>
        <div class="card-body overflow-auto">
          <table class="table table-sm mb-0 identification-table">
            <tr>
              <td><b>{{ $t('ID Document Type') }}</b></td>
              <td>
                <span v-if="identification.document_type">
                  {{ currentDocumentType }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="border-top-0"><b>{{ $t('Personal Identification Number') }}</b></td>
              <td class="border-top-0">{{ identification.personal_identification_number }}</td>
            </tr>
            <tr>
              <td><b>{{ $t('Document Number') }}</b></td>
              <td>{{ identification.document_number }}</td>
            </tr>
            <tr>
              <td><b>{{ $t('Date of issue') }}</b></td>
              <td>
                <span v-if="identification.document_issue_date">
                  {{ identification.document_issue_date | toDate }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Expiration Date') }}</b></td>
              <td>
                <span v-if="identification.document_expiry_date">
                  {{ identification.document_expiry_date | toDate }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Residency') }}</b></td>
              <td>
                <span v-if="identification.residency_code">
                  {{ identification.residency_code | countryNameByCode }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Citizenship') }}</b></td>
              <td>
                <span v-if="identification.citizenship_code">
                  {{ identification.citizenship_code | countryNameByCode }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Country of Birth') }}</b></td>
              <td>
                <span v-if="identification.country_of_birth_code">
                  {{ identification.country_of_birth_code | countryNameByCode }}
                </span>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Government Issued ID') }}</b></td>
              <td>
                <ul class="clean-list">
                  <li v-for="file of identification.government_issued_id_files" :key="file.uuid">
                    <b-button class="p-0" variant="link" @click="getAttachmentUrl(file.uuid)">
                      {{ file.name }}
                    </b-button>
                    <span>
                      at {{file.created_at | toDate}} by {{file.created_by.display_name}}
                    </span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Proof of Address') }}</b></td>
              <td>
                <ul class="clean-list">
                  <li v-for="file of identification.proof_of_address_files" :key="file.uuid">
                    <b-button class="p-0" variant="link" @click="getAttachmentUrl(file.uuid)">
                      {{ file.name }}
                    </b-button>
                    <span>
                      at {{file.created_at | toDate}} by {{file.created_by.display_name}}
                    </span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Employment Information') }}</b></td>
              <td>
                <ul class="clean-list">
                  <li v-for="file of identification.employment_information_files" :key="file.uuid">
                    <b-button class="p-0" variant="link" @click="getAttachmentUrl(file.uuid)">
                      {{ file.name }}
                    </b-button>
                    <span>
                      at {{file.created_at | toDate}} by {{file.created_by.display_name}}
                    </span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Company ID Documents') }}</b></td>
              <td>
                <ul class="clean-list">
                  <li v-for="file of identification.company_id_documents_files" :key="file.uuid">
                    <b-button class="p-0" variant="link" @click="getAttachmentUrl(file.uuid)">
                      {{ file.name }}
                    </b-button>
                    <span>
                      at {{file.created_at | toDate}} by {{file.created_by.display_name}}
                    </span>
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><b>{{ $t('Company Reg. Number') }}</b></td>
              <td>
                <span v-if="identification.company_reg_number">
                  {{ identification.company_reg_number }}
                </span>
              </td>
            </tr>


            <tr>
              <td><b>{{ $t('Place of Issue') }}</b></td>
              <td>{{ identification.place_of_issue }}</td>
            </tr>
            <tr>
              <td><b>{{ $t('Date of Birth') }}</b></td>
              <td>
                <span v-if="identification.date_of_birth">
                  {{ identification.date_of_birth | toDate }}
                </span>
              </td>
            </tr>

            <template v-for="dynamicField in identificationDynamicFields">
              <tr v-if="identification && identification.dynamic_fields"
                  :key="`identity_verification_dynamic_fields_${dynamicField.key}`">
                <td >
                  <b>{{ dynamicField.label }}</b>
                </td>
                <td class="border-bottom border-top-0" v-if="dynamicField.type === 'checkbox'">
                  <span v-if="identification.dynamic_fields.hasOwnProperty(dynamicField.key)" v-as-status="identification.dynamic_fields[dynamicField.key] ? 'checked' : 'unchecked'">
                    {{ identification.dynamic_fields[dynamicField.key] ? $t('Yes') : $t('No') }}
                  </span>
                </td>
                <td class="border-bottom border-top-0" v-else-if="identification.dynamic_fields.hasOwnProperty(dynamicField.key)">
                  {{ identification.dynamic_fields[dynamicField.key] | striptags | truncate(200) }}
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
      <div class="card" v-permission="'view_customerbankaccount'">
         <div class="card-header">
          <h5 class="d-inline-block mb-0">
            {{ $t('Card/Payment Method on File') }}
          </h5>
        </div>
        <div class="card-body">
          <template v-if="onlinePaymentMethods.loading">
            <spinner show height="20" size="5"/>
          </template>
          <b-list-group flush v-else>
            <b-list-group-item v-for="method in onlinePaymentMethods.data" :key="method.uuid" class="py-3 pm-row">
              <div class="d-flex align-items-center">
                <template v-if="method.type === 'card'">
                  <div class="pm-icon mr-3 d-flex align-items-center justify-content-center" :title="method.metadata.brand">
                    <font-awesome-icon :icon="brandFaIcon(method.metadata.brand)" class="icon ml-2 pm-icon-fa"/>
                  </div>

                  <div class="flex-grow-1">
                    <div class="font-weight-600">
                      <span>{{ method.metadata.brand }} •••• {{ method.metadata.last4 }}</span>
                    </div>
                    <small class="text-muted">
                      Expires {{ expiry(method.metadata) }}
                    </small>
                  </div>
                  <div>
                    <div class="font-weight-600">
                      <span class="pm-flags ml-2 d-flex align-items-center">
                        <i
                          :class="method.is_active ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-muted'"
                          class="pm-flag mx-1"
                          :title="method.is_active ? $t('Active') : $t('Inactive')"
                          :aria-label="method.is_active ? $t('Active') : $t('Inactive')"
                        ></i>
                        <i
                          :class="method.is_default ? 'fas fa-star text-warning' : 'fas fa-star text-muted'"
                          class="pm-flag mx-1"
                          :title="method.is_default ? $t('Default') : $t('Not default')"
                          :aria-label="method.is_default ? $t('Default') : $t('Not default')"
                        ></i>
                      </span>
                    </div>
                  </div>
                </template>
                <span v-else>
                  {{method.type}}
                </span>

              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div>
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{ $t('Commissions') }}
            </h5>
            <b-button class="float-right p-0" variant="link"
                      v-permission="'change_customer'"
                      @click="toggleCommissionsModal(true)">
              <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Edit') }}
            </b-button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 border-right">
                <table v-if="commissions && commissions.length > 0" class="info-table table table-sm">
                  <tr>
                    <th class="border-top-0">{{ $t('Percentage') }}</th>
                    <th class="border-top-0" v-if="commissions.length > 1">{{ $t('Over') }}</th>
                  </tr>
                  <tr v-for="(commission, index) in commissions" :key="index">
                    <td>{{ commission.percent }} %</td>
                    <td v-if="commissions.length > 1">{{ (commission.amount_over || 0) | asCurrency }}</td>
                  </tr>
                </table>
                <no-data-available v-else :height="5"/>
              </div>
              <div class="col-md-6">
                <table class="info-table table mb-0 table-sm">
                  <tr>
                    <td class="border-top-0 font-weight-bold">{{ $t('Minimum commission') }}</td>
                    <td class="border-top-0">{{ minimum_commission | asCurrency }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('L/D Warranty ') }}</td>
                    <td>{{ insurance_rate | asPercentage }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('Entry Fee') }}</td>
                    <td>{{ lot_handling_charge | asCurrency }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('Rebate') }}</td>
                    <td>{{ rebate_rate | asPercentage }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{ $t('Premiums') }}
            </h5>
            <b-button class="float-right p-0" variant="link"
                      v-permission="'change_customer'"
                      @click="togglePremiumsModal(true)">
              <font-awesome-icon :icon="'pen'" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Edit') }}
            </b-button>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 border-right">
                <table v-if="premiums && premiums.length > 0" class="info-table table table-sm">
                  <tr>
                    <th class="border-top-0">{{ $t('Percentage') }}</th>
                    <th class="border-top-0" v-if="premiums.length > 1">{{ $t('Over') }}</th>
                  </tr>
                  <tr v-for="(premium, index) in premiums" :key="index">
                    <td>{{ premium.percent }} %</td>
                    <td v-if="premiums.length > 1">{{ (premium.amount_over || 0) | asCurrency }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">{{ $t('Minimum premium') }}</td>
                    <td>{{ minimum_premium | asCurrency }}</td>
                  </tr>
                </table>
                <no-data-available v-else :height="5"/>
              </div>
            </div>
          </div>
        </div>
        <red-flag class="mt-3" ref="red_flag"/>
      </div>
    </div>


    <tax-status-modal/>
    <tax-rate-modal/>
    <vat-number-modal/>
    <payment-terms-modal/>
    <credit-limit-modal/>
    <bank-account-modal/>
    <commissions-modal/>
    <settlement-days-modal/>
    <payment-method-modal/>
    <customer-identification-modal/>
    <premiums-modal/>
    <customer-trust-level-modal/>
    <dynamic-field-modal/>
  </div>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import TaxStatusModal from "./modals/TaxStatusModal";
  import VatNumberModal from "./modals/VatNumberModal";
  import PaymentTermsModal from "./modals/PaymentTermsModal";
  import BankAccountModal from "./modals/BankAccountModal";
  import NoDataAvailable from "../../../../core/components/common/NoDataAvailable";
  import CommissionsModal from "./modals/CommissionsModal";
  import CreditLimitModal from "./modals/CreditLimitModal";
  import SettlementDaysModal from "./modals/SettlementDaysModal";
  import RedFlag from "./RedFlag";
  import TaxRateModal from "./modals/TaxRateModal";
  import PaymentMethodModal from "@/modules/customer/view/terms/modals/PaymentMethodModal";
  import cloneDeep from 'lodash/cloneDeep'
  import CustomerIdentificationModal from "@/modules/customer/view/terms/modals/CustomerIdentificationModal";
  import helperService from "@/core/services/helper.service";
  import CustomerTrustLevelModal from "./modals/CustomerTrustLevelModal.vue";
  import CustomerService from "@/modules/customer/CustomerService";
  import PremiumsModal from "./modals/PremiumsModal";
  import DynamicFieldModal from "./modals/DynamicFieldModal";
  import _ from "lodash";
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import Select2 from "@/core/components/select2/Select2.vue";
  import {hasPermission} from "@/core/directives/permission";
  import Spinner from "@/core/components/common/Spinner.vue";
  import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faCcJcb,
  faCcDinersClub,
  faCcApplePay,
  faCcAmazonPay,
  faCcPaypal,
} from '@fortawesome/free-brands-svg-icons';
  const {mapState, mapActions, mapMutations} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "Terms",
    components: {
      Spinner,
      Select2,
      InputWidget,
      CustomerTrustLevelModal,
      CustomerIdentificationModal,
      PaymentMethodModal,
      TaxRateModal,
      RedFlag,
      SettlementDaysModal,
      CreditLimitModal,
      CommissionsModal,
      NoDataAvailable,
      BankAccountModal,
      PaymentTermsModal,
      VatNumberModal,
      TaxStatusModal,
      PremiumsModal,
      DynamicFieldModal
    },
    methods: {
      ...mapActions([
        'toggleTaxStatusModal',
        'toggleTaxRateModal',
        'toggleVatNumberModal',
        'togglePaymentMethodModal',
        'togglePaymentTermsModal',
        'toggleSettlementDaysModal',
        'toggleCreditLimitModal',
        'toggleBankAccountModal',
        'toggleCommissionsModal',
        'togglePremiumsModal',
        'toggleTrustLevelModal',
        'saveTermsPartialData',
        'getTermsData',
        'getIdentificationData',
        'removeBankAccount',
        'showCustomerIdentificationModal',
        'toggleCreditCardVerification',
        'updateCustomer',
        'updateCustomerTermsDynamicFields',
        'toggleDynamicFieldModal',
        'toggleIsPickup',
        'getOnlinePaymentMethods',
        'toggleExcludeFromAutoPayments',
        'partialUpdateCustomer'
      ]),
      ...mapMutations(['updateTermsData']),
      getDynamicFieldValue(name, type) {
        if (this.customer.term.dynamic_fields[this.currentBranch.uuid]) {
          return this.customer.term.dynamic_fields[this.currentBranch.uuid][name];
        }
        return type == 'checkbox' ? false : '';
      },
      async onDynamicFieldToggle(field, checked) {
        let fieldName = field.name;
        let action = checked ? 'enable' : 'disable';
        const success = await this.confirmMessage(
          `Are you sure you would like to {action} <b>{field_label}</b> for Customer: <br/><b>{customer_no} {first_name} {last_name} - {email}</b>?`,
          {
            action: action,
            field_label: field.label,
            customer_no: this.customer.no,
            first_name: this.customer.first_name,
            last_name: this.customer.last_name,
            email: this.customer.email,
          }
        );
        if (!success) {
          return;
        }
        if (!this.customer.term.dynamic_fields[this.currentBranch.uuid]) {
          this.customer.term.dynamic_fields[this.currentBranch.uuid] = {};
        }
        this.customer.term.dynamic_fields[this.currentBranch.uuid][fieldName] = checked;
        console.log(this.customer.term.dynamic_fields[this.currentBranch.uuid]);
        let response = await this.updateCustomerTermsDynamicFields({
          key: fieldName,
          value: this.customer.term.dynamic_fields[this.currentBranch.uuid][fieldName]
        });
        if (response.success) {
          this.$toast('success', this.$t('updated successfully'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          }
        }
      },
      async onIdentificationVerificationChange(value) {
        let success, comment;
        if (value.value !== 'unverified') {
          success = await this.confirmMessage(
            `Are you sure you would like to mark Customer: <br/>{customer_no} {first_name} {last_name} - {email} <br/>identity as ${value.value}?`,
            {
              customer_no: this.customer.no,
              first_name: this.customer.first_name,
              last_name: this.customer.last_name,
              email: this.customer.email,
            }
          );
          comment = '';
          if (!success) {
            this.identity_verification = this.termsData.identity_verification;
            return;
          }
        } else {
          ({success, comment} = await this.$confirmWithComment(
            this.$i18n.t(`Are you sure you would like to mark Customer: <br/>{customer_no} {first_name} {last_name} - {email} <br/>identity as unverified?`, {
              customer_no: this.customer.no,
              first_name: this.customer.first_name,
              last_name: this.customer.last_name,
              email: this.customer.email,
            }),
            this.$i18n.t('Please Confirm'),
            this.$i18n.t('Yes'),
            this.$i18n.t('No'),
            this.$i18n.t('Comment'),
            'required|min:3|max:1024',
            null,
          ));
          if (!success) {
            this.identity_verification = this.termsData.identity_verification;
            return;
          }
        }
        const status = await this.getCustomerStatus(value.value === 'verified')
        const payload = {
          id: this.customer.uuid,
          data: {
            status: status,
            term: {
              identity_verification: value.value,
              identity_verification_rejected_reason: comment
            },
          }
        };
        await this.performPartialUpdate(payload, 'Identification check was saved successfully');
      },
      async onCreditCardVerificationCheckChange(checked) {
        let msg = this.$i18n.t("Please note that activating this checkbox, will mark customer as verified credit/debit card owner and they will be exempt from credit/debit card verification process when registering for the auction. Would you like to proceed?")
        if (!checked) {
          msg = this.$i18n.t("Please note that deactivating this checkbox, will unmark customer as verified credit/debit card owner and they will be required to go through the credit/debit card verification process when registering for the auction. Would you like to proceed?")
        }
        this.$confirm(
          msg,
          this.$i18n.t('Credit Card Verification was saved successfully'),
          () => {
            return this.toggleCreditCardVerification(checked);
          }
        );
      },
      onPickupChange: _.debounce(async function (checked) {
        let response = await this.saveTermsPartialData({is_pickup: checked});
        if (response.success) {
          this.$toast('success', this.$i18n.t('Pickup / Collection was successfully updated'));
        }
        return true
      }, 1000),
      async onExcludeFromAutoPaymentsCheckChange(checked) {
        this.$confirm(
            checked ? this.$i18n.t("Please note that activating this checkbox, will exclude this customer from Auto-Payments. Would you like to proceed?") : this.$i18n.t("Please note that activating this checkbox, will include this customer in Auto-Payments. Would you like to proceed?"),
            this.$i18n.t('Exclude from Auto-Payments was saved successfully'),
            () => {
              return this.toggleExcludeFromAutoPayments(checked);
            }
        );
      },
      onBankAccountRemoveClick() {
        this.$confirm(
          this.$i18n.t("Are you sure you want to delete following bank account?"),
          this.$i18n.t('Bank account was successfully deleted'),
          this.removeBankAccount,
        );
      },
      async onIdentificationDetailsEditClick() {
        await this.getIdentificationData()
        this.showCustomerIdentificationModal({
          object: cloneDeep(this.identification)
        })
      },
      async getAttachmentUrl(uuid) {
        const response = await CustomerService.getCustomerAttachment(uuid)
        window.open(response.body.presigned_url, '_blank')
      },
      async onKYCVerificationChange(value) {

        let success, comment;
        if (value.value !== 'unverified') {
          const success = await this.confirmMessage(
            `Are you sure you would like to mark Customer:<br/>{customer_no} {first_name} {last_name} - {email} <br/>Account/KYC status as ${value.value}?`,
            {
              customer_no: this.customer.no,
              first_name: this.customer.first_name,
              last_name: this.customer.last_name,
              email: this.customer.email,
            }
          );
          comment = '';
          if (!success) {
            this.kyc_status_verification = this.termsData.kyc_status_verification;
            return;
          }
        } else {
          ({success, comment} = await this.$confirmWithComment(
            this.$i18n.t(`Are you sure you would like to mark Customer: <br/>{customer_no} {first_name} {last_name} - {email} <br/>Account/KYC status as unverified?`, {
              customer_no: this.customer.no,
              first_name: this.customer.first_name,
              last_name: this.customer.last_name,
              email: this.customer.email,
            }),
            this.$i18n.t('Please Confirm'),
            this.$i18n.t('Yes'),
            this.$i18n.t('No'),
            this.$i18n.t('Comment'),
            'required|min:3|max:1024',
            null,
          ));
          if (!success) {
            this.kyc_status_verification = this.termsData.kyc_status_verification;
            return;
          }
        }
        const status = await this.getCustomerStatus(value.value === 'verified')
        const payload = {
          id: this.customer.uuid,
          data: {
            status: status,
            term: {
              kyc_status_verification: value.value,
              kyc_rejected_reason: comment
            },
          }
        };
        await this.performPartialUpdate(payload, 'Account/KYC Approved was saved successfully');
      },
      async confirmMessage(message, params = null) {
        return await this.$confirm(
          this.$i18n.t(message, params),
          null,
          null,
          null,
          this.$i18n.t('Please Confirm'),
          this.$i18n.t('Yes'),
          this.$i18n.t('No'),
          null,
        );
      },
      async performPartialUpdate(payload, successMessage) {
        const response = await this.partialUpdateCustomer({payload, expand: 'term'});
        if (response.success) {
          this.$toast('success', this.$t(successMessage));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          }
        }
      },
      async getCustomerStatus(checked) {
        let statusChangeConfirmed = false;
        if (checked && this.customer.status !== 'active') {
          const confirmStatusMsg = this.$i18n.t('Customer status is currently set as Pending/Blocked would you like to change their status to Active?');
          statusChangeConfirmed = await this.confirmMessage(confirmStatusMsg);
        }
        return checked && statusChangeConfirmed ? 'active' : this.customer.status
      },
      async onPreApproveCommissionBidsCheckChange(checked) {
        const res = await this.$confirm(
            checked ? this.$i18n.t("Please note that activating this checkbox, will auto approve customer's commission bids. Would you like to proceed?") :
              this.$i18n.t("Please note that deactivating this checkbox, will disable auto approval of commission bids for this customer. Would you like to proceed?"),
            this.$i18n.t('Pre Approval of Commission bids was saved successfully'));
        if (res) {
          return this.saveTermsPartialData({pre_approve_commission_bids: checked});
        }
      },
      async onPreApproveTelephoneBidsCheckChange(checked) {
        const res = await this.$confirm(
            checked ? this.$i18n.t("Please note that activating this checkbox, will auto approve customer's telephone bids. Would you like to proceed?") :
              this.$i18n.t("Please note that deactivating this checkbox, will disable auto approval of telephone bids for this customer. Would you like to proceed?"),
            this.$i18n.t('Pre Approval of telephone bids was saved successfully'));
        if (res) {
          return this.saveTermsPartialData({pre_approve_telephone_bids: checked});
        }
      },
      expiry(m) {
        const dt = new Date(m.exp_year, (m.exp_month || 1) - 1, 1);
        return dt.toLocaleString(undefined, {month: 'short', year: 'numeric'});
      },
      brandFaIcon(brand = '') {
        const b = brand.toLowerCase()
        // return [prefix, name] pairs (brands = 'fab', solid = 'fas')
        if (b.includes('visa')) return faCcVisa;
        if (b.includes('master')) return faCcMastercard;
        if (b.includes('amex') || b.includes('american express')) return faCcAmex;
        if (b.includes('discover')) return faCcDiscover;
        if (b.includes('jcb')) return faCcJcb;
        if (b.includes('diners')) return faCcDinersClub;
        if (b.includes('paypal')) return faCcPaypal;
        if (b.includes('apple')) return faCcApplePay;
        if (b.includes('amazon')) return faCcAmazonPay;
        // fallback generic card
        return faCreditCard;
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        currentTaxStatusUuid: state => state.termsData.tax_status_uuid,
        payment_terms: state => state.termsData.payment_terms,
        settlement_days: state => state.termsData.settlement_days,
        credit_limit: state => state.termsData.credit_limit,
        vat_number: state => state.termsData.vat_number,
        payment_method: state => state.termsData.payment_method,
        tax_rate: state => state.termsData.tax_rate,
        bank_account: state => state.termsData.bank_account,
        commissions: state => {
          let data = helperService.reverseCalculateTiers({commissions: cloneDeep(state.termsData.commissions)})
          return data.commissions
        },
        premiums: state => {
          let data = helperService.reverseCalculateTiers({premiums: cloneDeep(state.termsData.premiums)})
          return data.premiums
        },
        lot_handling_charge: state => state.termsData.lot_handling_charge,
        minimum_commission: state => state.termsData.minimum_commission,
        minimum_premium: state => state.termsData.minimum_premium,
        insurance_rate: state => state.termsData.insurance_rate,
        rebate_rate: state => state.termsData.rebate_rate,
        is_pickup: state => state.termsData.is_pickup,
        termsData: state => state.termsData,
        credit_card_verified: state => !!state.customer.credit_card_verified_at,
        identification: state => state.termsData.identification,
        kyc_status_approved: state => state.termsData.kyc_status_approved,
        pre_approve_commission_bids: state => state.termsData.pre_approve_commission_bids,
        pre_approve_telephone_bids: state => state.termsData.pre_approve_telephone_bids,
        exclude_from_auto_payments: state => state.termsData.exclude_from_auto_payments,
        onlinePaymentMethods: state => state.onlinePaymentMethods,

      }),
      ...globalMapState(['taxStatuses', 'isSalesTaxEnabled', 'customerIdentificationTypes', 'currentBranch', 'identityVerificationTypes', 'kycVerificationTypes', 'identificationDynamicFields','hasStripeProvider']),
      currentTaxStatusName() {
        const taxStatus = this.taxStatuses.find(status => status.uuid === this.currentTaxStatusUuid);
        return taxStatus ? taxStatus.name : '';
      },
      currentDocumentType() {
        const documentType = this.customerIdentificationTypes.find(status => status.value === this.identification.document_type);
        return documentType ? documentType.key : '';
      },
      currentTrustLevel() {
        if (!this.currentBranch.enable_trust_levels || !this.customer.trust_level) {
          return null;
        }
        for (let trustLevelIndex in this.currentBranch.trust_levels) {
          let trustLevel = this.currentBranch.trust_levels[trustLevelIndex];
          if (trustLevel.uuid === this.customer.trust_level.trust_level_uuid) {
            return {...trustLevel, disable_auto_promotion: this.customer.trust_level.disable_auto_promotion};
          }
        }
        return null;

      }
    },
    watch: {
      termsData() {
        this.identity_verification = this.termsData.identity_verification;
      }
    },
    async mounted() {
      await this.getTermsData();
      this.identity_verification = this.termsData.identity_verification;
      this.kyc_status_verification = this.termsData.kyc_status_verification;
      if (hasPermission('view_customerbankaccount')) {
        this.getOnlinePaymentMethods();
      }
    },
    data() {
      return {
        kyc_status_verification: null,
        identity_verification: null,
      }
    },
    async beforeRouteLeave(to, from, next) {
      if (await this.$refs.red_flag.beforeRouteLeave()) {
        return next()
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "./../../scss/variables";

  .identification-table {
    tr {
      td {
        &:first-child {
          width: 35%;
        }

        overflow-wrap: anywhere;
      }
    }
  }

  .clean-list {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .grid-wrapper {
    display: grid;
    grid-gap: 1em;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 1em;

    .general-info-table {

      button {
        visibility: hidden;
      }

      td:first-child {
        width: 15em;
      }


      tr:hover {
        button {
          visibility: visible;
        }

        td {
          background-color: lighten($secondary, 6);
        }
      }
    }

    .nested-grid-wrapper {
      display: grid;
      grid-gap: 1em;
      grid-template-columns: 1fr;
    }
  }

  .bt-0 {
    border-top: 0;
  }
  .pm-card {
    border: none;
    border-radius: .5rem;
    box-shadow: 0 1px 2px rgba(0,0,0,.06), 0 1px 3px rgba(0,0,0,.08);
  }
  /* Rows */
  .pm-row { border-left: 0; border-right: 0; }
  .pm-row:hover { background: #f8f9fb; }

  /* Text */
  .pm-title { font-weight: 600; }

  .pm-icon-fa{ font-size: 1.15rem; line-height: 1; }

  /* Flag icons */
  .pm-flag { font-size: .95rem; }
  .pm-flags .text-warning { color: #f0ad4e !important; } /* Bootstrap 4 feel */
  @media only screen and (max-width: map-get($grid-breakpoints, "xl")) {
    .grid-wrapper {
      grid-template-columns: 1fr;
    }
  }
</style>

